<template>
  <article class="page privacy">
    <h1 class="page-title">Privacy policy</h1>
    <p class="page-lede">Effective {{ EFFECTIVE_DATE }}</p>

    <section>
      <h2>The short version</h2>
      <p>
        Rentz Score doesn't collect, send or share any of your data. Everything you enter stays on
        your device.
      </p>
    </section>

    <section>
      <h2>What the app stores</h2>
      <p>To keep score, the app saves the following on your device only:</p>
      <ul>
        <li>the player names you type in</li>
        <li>the scores for each round and which game was played</li>
        <li>your past games, so you can see them in History or resume them</li>
      </ul>
      <p>
        This data is never uploaded. There are no accounts, and the app doesn't ask for your name,
        email, location, contacts or any other personal information.
      </p>
    </section>

    <section>
      <h2>No tracking, ads or third parties</h2>
      <p>
        The app has no analytics, advertising, crash reporting or third-party services. It doesn't
        need an internet connection to work.
      </p>
    </section>

    <section>
      <h2>Deleting your data</h2>
      <p>
        You can delete any past game from History. To remove everything, clear the app's storage in
        your device settings or uninstall the app. Because nothing is stored anywhere else, that
        deletes your data completely.
      </p>
    </section>

    <section>
      <h2>Children</h2>
      <p>
        The app is suitable for all ages and collects no information from anyone, including
        children.
      </p>
    </section>

    <section>
      <h2>Changes to this policy</h2>
      <p>
        If the app ever changes how it handles data, this page will be updated and the effective
        date above will change.
      </p>
    </section>

    <section>
      <h2>Contact</h2>
      <p>
        Questions about this policy:
        <a :href="`mailto:${CONTACT_EMAIL}`">{{ CONTACT_EMAIL }}</a>
      </p>
    </section>
  </article>
</template>

<script setup>
const EFFECTIVE_DATE = '20 October 2026';
const CONTACT_EMAIL = 'alex.ciocan.dev@gmail.com';
</script>

<style scoped>
.privacy {
  max-width: 680px;
}

section {
  margin-top: 1.75rem;
}

h2 {
  font-family: var(--font-display);
  font-size: var(--step-1);
  font-weight: 600;
  margin-bottom: 0.5rem;
}

p,
li {
  color: var(--on-table-muted);
  line-height: 1.55;
}

p + p,
ul + p {
  margin-top: 0.75rem;
}

ul {
  margin: 0.5rem 0 0 1.25rem;
}

a {
  color: var(--on-table);
  text-underline-offset: 2px;
}
</style>
